import { render, staticRenderFns } from "./receiptReceivingSubsDerated.vue?vue&type=template&id=1ece3aa6&"
import script from "./receiptReceivingSubsDerated.vue?vue&type=script&lang=js&"
export * from "./receiptReceivingSubsDerated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports